import api from './axios';

export function getEmailSettings() {
  return api.get('/email-settings').then((r) => r.data);
}

export function updateEmailSender(payload) {
  return api.put('/email-settings/sender', payload).then((r) => r.data);
}

export function updateEmailTrigger(key, enabled) {
  return api
    .put(`/email-settings/triggers/${encodeURIComponent(key)}`, { enabled })
    .then((r) => r.data);
}

export function sendTestEmail(to) {
  return api.post('/email-settings/test', to ? { to } : {}).then((r) => r.data);
}
